import React, { useState, useContext, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid2,
  Drawer,
  Tooltip,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import NodeConfigModal from "./menus/NodeConfigModal";
import NodesDynamicForm from "../../forms/NodesDynamicForm";
import AddNodeContext from "../../contexts/AddNodeContext";
import nodeTypesConfig from "../../models/nodeTypesConfig";
import useAutomations from "../../hooks/automationhooks/useAutomations";
import WhatsappSideMenu from "./menus/WhatsappSideMenu";
import { useParams } from "react-router-dom";
import { useThemeContext } from "../../Theme/Theme";
import SMSSideMenu from "./menus/SMSSideMenu";
import EmailSideMenu from "./menus/EmailSideMenu";
import SmsTemplateSelection from "./menus/SMSTemplateSelection";
import WhatsappTemplateSelection from "./menus/WhatsappTemplateSelection";
import EmailTemplateSelection from "./menus/EmailTemplateSelection";
import CRMSideMenu from "./menus/CRMSideMenu";

const AddActionButton = ({ edgeId }) => {
  const [optionsModalOpen, setOptionsModalOpen] = useState(false);
  const [templateSel, setTemplateSel] = useState({ open: false, type: null });
  const [preSelectedTemplate, setPreSelectedTemplate] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const {
    whatsappTemplates,
    emails,
    smsTemplates,
    handleGetSmsTemplates,
    handleGetWhatsappNumbers,
    handleGetWhatsappTemplates,
    handleGetEmails,
    refreshWhatsappTemplates,
    refreshEmailTemplates,
    refreshSmsTemplates,
  } = useAutomations();
  const { mode } = useThemeContext();
  const { automationId, brandId } = useParams();

  const [configModal, setConfigModal] = useState({
    open: false,
    content: null,
    isDrawer: false,
  });
  const { addNodeBetweenNodes } = useContext(AddNodeContext);

  useEffect(() => {
    const currentBrandId = brandId || localStorage.getItem("brandId");
    if (currentBrandId) {
      handleGetWhatsappNumbers(currentBrandId);
      handleGetWhatsappTemplates(currentBrandId);
      handleGetSmsTemplates(currentBrandId);
    }
  }, [brandId]);

  useEffect(() => {
    const currentBrandId = brandId || localStorage.getItem("brandId");
    if (currentBrandId) {
      handleGetEmails(currentBrandId);
    }
  }, [brandId]);

  const handleOptionsButtonClick = (event) => {
    event.stopPropagation();
    setOptionsModalOpen(true);
  };

  const handleOptionsModalClose = () => {
    setOptionsModalOpen(false);
  };

  const handleConfigModalClose = () => {
    setConfigModal({ open: false, content: null, isDrawer: false });
  };

  const handleOptionSelect = (type) => {
    setOptionsModalOpen(false);

    if (["smsMessage", "whatsappMessage", "emailMessage"].includes(type)) {
      setTemplateSel({ open: true, type });
      return;
    }

    const nodeTypeConfig = nodeTypesConfig.actions.find(
      (node) => node.type === type
    );

    if (!nodeTypeConfig) {
      console.error(`Unknown node type: ${type}`);
      return;
    }

    if (nodeTypeConfig.formFields && nodeTypeConfig.formFields.length > 0) {
      const formFields = nodeTypeConfig.formFields.map((field) => {
        return field;
      });

      if (type == "whatsappMessage") {
        setConfigModal({
          open: true,
          isDrawer: true,
          content: (
            <WhatsappSideMenu
              onSubmit={(formData) => {
                formData = {
                  label: "Whatsapp Message",
                  template: {
                    label: formData.TemplateName,
                    value: formData.TemplateId,
                    placeholderMappings: formData.placeholderMappings,
                  },
                };
                addNodeBetweenNodes(type, formData, edgeId);
              }}
              onClose={handleConfigModalClose}
              isDrawer={true}
            />
          ),
        });
      } else if (type == "smsMessage") {
        setConfigModal({
          open: true,
          isDrawer: true,
          content: (
            <SMSSideMenu
              onSubmit={(formData) => {
                addNodeBetweenNodes(type, formData, edgeId);
              }}
              onClose={handleConfigModalClose}
              isDrawer={true}
            />
          ),
        });
      } else if (type === "emailMessage") {
        setConfigModal({
          open: true,
          isDrawer: true,
          content: (
            <EmailSideMenu
              onSubmit={(formData) => {
                addNodeBetweenNodes(type, formData, edgeId);
              }}
              onClose={handleConfigModalClose}
              isDrawer={true}
            />
          ),
        });
      } else if (type === "sendToCrm") {
        setConfigModal({
          open: true,
          isDrawer: true,
          content: (
            <CRMSideMenu
              onSubmit={(formData) => {
                addNodeBetweenNodes(type, formData, edgeId);
              }}
              onClose={handleConfigModalClose}
            />
          ),
        });
      } else if (type === "customNodeCommand") {
        const nodeTypeConfig = nodeTypesConfig.actions.find(
          (node) => node.type === type
        );

        const formFields = nodeTypeConfig.formFields.map((field) => {
          return field;
        });

        setConfigModal({
          open: true,
          isDrawer: true,
          content: (
            <NodesDynamicForm
              title={`Create ${nodeTypeConfig.displayName} Node`}
              onClose={handleConfigModalClose}
              formFields={formFields}
              onSubmit={(formData) => {
                addNodeBetweenNodes(type, formData, edgeId);
                handleConfigModalClose();
              }}
              setConfigModal={setConfigModal}
              handleCancel={() =>
                setConfigModal({ open: false, isDrawer: false })
              }
            />
          ),
        });
      } else {
        setConfigModal({
          open: true,
          isDrawer: true,
          content: (
            <NodesDynamicForm
              title={`${nodeTypeConfig.displayName}`}
              onClose={handleConfigModalClose}
              formFields={formFields}
              onSubmit={(formData) => {
                addNodeBetweenNodes(type, formData, edgeId);
                handleConfigModalClose();
              }}
              setConfigModal={setConfigModal}
              handleCancel={() =>
                setConfigModal({ open: false, isDrawer: false })
              }
            />
          ),
        });
      }
    } else {
      addNodeBetweenNodes(type, {}, edgeId);
    }
  };

  const handleTemplateChosen = (tmpl) => {
    const { type } = templateSel;
    setTemplateSel({ open: false, type: null });
    setPreSelectedTemplate(tmpl);

    const openConfig = (node) =>
      setConfigModal({ open: true, isDrawer: true, content: node });

    if (type === "smsMessage") {
      openConfig(
        <SMSSideMenu
          preSelectedTemplate={tmpl}
          onSubmit={(fd) =>
            addNodeBetweenNodes(
              "smsMessage",
              {
                label: tmpl.TemplateName,
                template: { label: tmpl.TemplateName, value: tmpl.TemplateId },
                ...fd,
              },
              edgeId
            )
          }
          onClose={handleConfigModalClose}
          isDrawer={true}
        />
      );
    } else if (type === "whatsappMessage") {
      openConfig(
        <WhatsappSideMenu
          preSelectedTemplate={tmpl}
          onSubmit={(fd) =>
            addNodeBetweenNodes(
              "whatsappMessage",
              {
                label: tmpl.TemplateName,
                template: {
                  label: tmpl.TemplateName,
                  value: tmpl.TemplateId,
                  placeholderMappings: fd.placeholderMappings,
                },
                ...fd,
              },
              edgeId
            )
          }
          onClose={handleConfigModalClose}
          isDrawer={true}
        />
      );
    } else if (type === "emailMessage") {
      openConfig(
        <EmailSideMenu
          preSelectedTemplate={tmpl}
          onSubmit={(fd) =>
            addNodeBetweenNodes(
              "emailMessage",
              { label: tmpl.TemplateName, id: tmpl.Id, ...fd },
              edgeId
            )
          }
          onClose={handleConfigModalClose}
          isDrawer={true}
        />
      );
    }
  };

  return (
    <>
      {/* Button with edge-specific styling */}
      <Tooltip title="Add" placement="top">
        <Button
          onClick={handleOptionsButtonClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          variant="contained"
          size="small"
          sx={{
            height: 15,
            width: 15,
            minWidth: 15,
            maxWidth: 15,
            borderRadius: "4px",
            backgroundColor: mode === "dark" ? "grey.800" : "grey.300",
            color: "#aaa",
            padding: 0,
            border: `1px solid ${isHovered ? "#1976d2" : "transparent"}`,
            transition: "border-color 0.2s",
            "&:hover": {
              backgroundColor: mode === "dark" ? "grey.800" : "grey.300",
            },
          }}
        >
          <AddIcon
            sx={{
              fontSize: 10,
              color: "#aaa",
            }}
          />
        </Button>
      </Tooltip>

      {/* Options Modal */}
      <Dialog
        open={optionsModalOpen}
        onClose={handleOptionsModalClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            minWidth: "600px",
            borderRadius: 8,
            bgcolor: "background.paper",
            color: "text.primary",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <DialogTitle
          sx={{ textAlign: "center", bgcolor: "background.default" }}
          color="companyBlue"
        >
          Select Action Node
        </DialogTitle>
        <DialogContent
          sx={{
            p: 3,
            pt: "24px !important",
            pb: "24px !important",
            overflow: "hidden",
            bgcolor: "background.paper",
            color: "text.primary",
          }}
        >
          <Grid2
            container
            spacing={3}
            justifyContent="center"
            alignItems="center"
            sx={{
              width: "100%",
              m: 0,
              p: "12px",
            }}
          >
            {nodeTypesConfig.actions.map((node) => (
              <Grid2
                item
                xs={12}
                sm={4}
                key={node.type}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => handleOptionSelect(node.type)}
                  sx={{
                    width: 180,
                    height: 180,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    p: 2,
                    transition: node.isWip ? "none" : "all 0.2s ease-in-out",
                    cursor: node.isWip ? "not-allowed" : "pointer",
                    opacity: node.isWip ? 0.4 : 1,
                    ...(node.isWip
                      ? { pointerEvents: "none" }
                      : {
                          "&:hover": {
                            transform: "scale(1.05)",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                          },
                        }),
                  }}
                >
                  <node.icon
                    sx={{ fontSize: "40px", mb: 2, color: "text.primary" }}
                  />
                  <div>{node.displayName}</div>
                </Button>
              </Grid2>
            ))}
          </Grid2>
        </DialogContent>
        <DialogActions sx={{ bgcolor: "background.default" }}>
          <Button
            variant="outlined"
            onClick={handleOptionsModalClose}
            color={"companyBlue"}
            sx={{
              minWidth: 100,
              textTransform: "none",
              borderColor: "companyBlue",
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 0.1)",
                borderColor: "rgba(255, 255, 255, 0.5)",
              },
            }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {/* Configuration Modal or Drawer */}
      {configModal.open &&
        (configModal.isDrawer ? (
          <Drawer
            open={configModal.open}
            onClose={handleConfigModalClose}
            anchor="left"
            PaperProps={{
              sx: {
                width: "1500px",
                maxWidth: "90vw",
              },
            }}
          >
            {configModal.content}
          </Drawer>
        ) : (
          <NodeConfigModal
            open={configModal.open}
            onClose={handleConfigModalClose}
          >
            {configModal.content}
          </NodeConfigModal>
        ))}

      {templateSel.open && templateSel.type === "smsMessage" && (
        <SmsTemplateSelection
          open
          templates={smsTemplates?.data || []}
          setSelected={handleTemplateChosen}
          setClosed={() => setTemplateSel({ open: false, type: null })}
          refreshTemplates={() => refreshSmsTemplates(brandId)}
          isDrawer={true}
        />
      )}

      {templateSel.open && templateSel.type === "whatsappMessage" && (
        <WhatsappTemplateSelection
          open
          templates={whatsappTemplates?.data?.Data?.List || []}
          setSelected={handleTemplateChosen}
          setClosed={() => setTemplateSel({ open: false, type: null })}
          refreshTemplates={() => refreshWhatsappTemplates(brandId)}
          isDrawer={true}
        />
      )}

      {templateSel.open && templateSel.type === "emailMessage" && (
        <EmailTemplateSelection
          open
          templates={emails?.data || []}
          setSelected={handleTemplateChosen}
          setClosed={() => setTemplateSel({ open: false, type: null })}
          refreshTemplates={() => refreshEmailTemplates(brandId)}
          isDrawer={true}
        />
      )}
    </>
  );
};

export default AddActionButton;
